export default {"src":"/login-app/[GIT_HASH]/_next/static/media/warning_trend.a0bd805d.svg","height":16,"width":16,"blurWidth":0,"blurHeight":0};